import React, { Component } from 'react';
import './iamExReContent.css';
import IamExReUserCard from './iamExReUserCard/iamExReUserCard.js';
import IamExReInfoBox from './iamExReInfoBox/iamExReInfoBox.js';

class IamExReContent extends Component {

  state = {
    revokePermissionCheck: false
  };

  componentDidMount() {

  };

  render() {

    return (
      <div className="IamExReContentPage">
        <IamExReInfoBox users={this.props.users}/>
        {this.props.users.map(user => {
          return <IamExReUserCard key={user.UserId} user={user}/>;
        })}
      </div>
    );
  };

};

export default IamExReContent;


// WEBPACK FOOTER //
// ./src/components/content/iamExplorer/iamExReport/iamExReContent/iamExReContent.js